// Reportes de pago separados (salario sin extras / horas extras) para jornada especial 48 h.
import { exportReporteTabla, expandirFilasPorCuentas } from "@/lib/reportePago";

const r2 = (x) => Math.round((Number(x) || 0) * 100) / 100;
const nombre = (emp) => `${emp.nombre} ${emp.apellidos || ""}`.trim();
const sum = (rows, i) => r2(rows.reduce((s, r) => s + (Number(r[i]) || 0), 0));

// CCSS de las extras con la tasa propia del trabajador; la del salario se deriva de la planilla.
function split({ emp, calc }, ccssAplicaExtras) {
  const ccssExt = emp.ccss_aplica ? r2(calc.montoExt * calc.ccssRate * (calc.ccssFraccion ?? 1)) : 0;
  const ccssSal = r2(Math.max(0, ccssAplicaExtras ? calc.ccss - ccssExt : calc.ccss));
  const brutoSal = r2(calc.totalBruto - calc.montoExt);
  return { brutoSal, ccssSal, ccssExt };
}

export function exportReporteJornada48({ kind, formato, empresa, calculations, periodoLabel, fileLabel, periodEnd }) {
  const ccssAplicaExtras = !!empresa?.ccss_aplica_extras;
  let rows, headers, colTypes, widths, titulo, derive;
  if (kind === "salario") {
    titulo = "Reporte de Salario (sin horas extras)";
    headers = ["Empleado", "Identificación", "Salario Bruto (sin extras)", "CCSS", "Imp. Renta", "Rebajos", "Neto a Pagar"];
    colTypes = ["s", "s", "n", "n", "n", "n", "n"];
    widths = [36, 16, 20, 15, 15, 15, 17];
    rows = calculations.map(row => {
      const { brutoSal, ccssSal } = split(row, ccssAplicaExtras);
      const reb = r2(row.calc.totalRebajos);
      const renta = r2(row.calc.renta);
      return { emp: row.emp, valores: [brutoSal, ccssSal, renta, reb, r2(brutoSal - ccssSal - renta - reb)] };
    });
    derive = (a) => { a[4] = r2(a[0] - a[1] - a[2] - a[3]); return a; };
  } else {
    titulo = "Reporte de Horas Extras";
    headers = ["Empleado", "Identificación", "Horas Extras", "Monto Bruto Extras", "CCSS", "Neto Extras"];
    colTypes = ["s", "s", "h", "n", "n", "n"];
    widths = [36, 16, 14, 18, 15, 17];
    rows = calculations.map(row => {
      const { ccssExt } = split(row, ccssAplicaExtras);
      const monto = r2(row.calc.montoExt);
      return { emp: row.emp, valores: [+(row.calc.hrsExt || 0).toFixed(2), monto, ccssExt, r2(monto - ccssExt)] };
    });
    derive = (a) => { a[3] = r2(a[1] - a[2]); return a; };
  }
  // Columna 2 (Identificación) se inserta luego de expandir por cuentas.
  const exp = expandirFilasPorCuentas(rows.map(r => ({ emp: r.emp, nombre: nombre(r.emp), valores: [String(r.emp.cedula || ""), ...r.valores] })), periodEnd,
    (a) => [a[0], ...derive(a.slice(1))]);
  rows = exp.rows;
  const totalRow = ["TOTAL GENERAL", "", ...headers.slice(2).map((_, k) => sum(rows, k + 2))];
  exportReporteTabla({
    empresa, titulo, headers, colTypes, widths, rows, totalRow, periodoLabel, formato,
    fileNameLabel: `${kind === "salario" ? "Reporte_Salario_sin_extras" : "Reporte_Horas_Extras"}_${fileLabel}`,
    sheetName: kind === "salario" ? "Salario sin extras" : "Horas extras",
    secundarias: exp.secundarias,
  });
}
